import SiteSettingStore from "@/cms/reducers/common/SiteSettingStore";

const CMSReducers = {
    SiteSettingStore
}

export default CMSReducers;
